"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typography = {
    family: "'Montserrat', sans-serif",
    weight: {
        thin: 300,
        regular: 400,
        medium: 500,
        semiBold: 600,
        bold: 700,
    },
    sizes: {
        desktop: {
            heading: {
                extraLarge: '2.5rem',
                large: '2rem',
                medium: '1.5rem',
                small: '1.25rem',
                extraSmall: '1rem',
            },
            paragraph: {
                extraLarge: '1.25rem',
                large: '1.125rem',
                medium: '1rem',
                small: '0.875rem',
                extraSmall: '0.75rem',
            },
        },
        mobile: {
            heading: {
                extraLarge: '2rem',
                large: '1.5rem',
                medium: '1.25rem',
                small: '1rem',
                extraSmall: '0.875rem',
            },
            paragraph: {
                extraLarge: '1.125rem',
                large: '1rem',
                medium: '0.875rem',
                small: '0.75rem',
                extraSmall: '0.625rem',
            },
        },
    },
    fixedSize: {
        extraSmall: '1.25rem',
        small: '1rem',
        medium: '0.875rem',
        large: '0.75rem',
        extraLarge: '0.625rem',
    },
};
exports.default = typography;
